import React from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import { useTranslation } from "react-i18next";

function HistoryTable({ data }) {
  // 1) Data
  const { t } = useTranslation();
  // 2) Functions
  const returnStatusText = (item) => {
    if (item.callStatus == 0 || item.callStatus == 1) {
      return t("Προς_Αναζήτηση");
    } else if (item.callStatus == 10 || item.callStatus == 11) {
      return t("Driver") + " : " + item.taxiNo;
    } else if (item.callStatus == 20 || item.callStatus == 21) {
      return t("Δεν_βρέθηκε_Όχημα");
    } else if (item.callStatus == 30 || item.callStatus == 31) {
      return t("Ακυρώθηκε");
    }
  };

  return (
    <div className="table-container ">
      {/*Desktop Table */}
      <table className="hideBigTable">
        <thead>
          <tr>
            <th>{t("Ημερομηνία")}</th>
            <th>{t("Destination")}</th>
            <th>{t("Αποτέλεσμα_κλήσης")}</th>
            <th>{t("Comment")}</th>
            <th>{t("Ολοκληρώθηκε")}</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <>
              <tr key={item.receivedDate} className="hover:bg-gray-300 ">
                <td>
                  <div className="bg-gray-200 text-center rounded-md p-1 h-14 flex items-center justify-center flex-col">
                    <p className="font-semibold">
                      {item.receivedDate.split("T")[1].split(".")[0]}
                      <br />
                      <span className=" font-normal">
                        {item.receivedDate.split("T")[0]}
                      </span>
                    </p>
                  </div>
                </td>
                <td>
                  <div className="bg-gray-200 text-center rounded-md p-1 h-14 flex items-center justify-center">
                    {item.destination == "" ? "-" : <>{item.destination}</>}
                  </div>
                </td>
                <td>
                  <div className="bg-gray-200 text-center rounded-md p-1 h-14 flex items-center justify-center">
                    {item.callStatus == "" ? (
                      "-"
                    ) : (
                      <>
                        {item.callStatus == 30 || item.callStatus == 31 ? (
                          <>{item.taxiNo}</>
                        ) : (
                          <> {returnStatusText(item)}</>
                        )}
                      </>
                    )}
                  </div>
                </td>
                {/* comments */}
                <td>
                  <div className="bg-gray-200 text-center rounded-md p-1 h-14 flex items-center justify-center">
                    <>
                      <div className="bg-gray-200 text-center rounded-md p-1 h-14 flex items-center justify-center">
                        {item.comments}
                      </div>
                    </>
                  </div>
                </td>
                <td>
                  <div className="bg-gray-200 text-center rounded-md p-1 h-14 flex items-center justify-center">
                    {item.callStatus === 10 || item.callStatus === 11 ? (
                      <>
                        <div className="flex items-center justify-center">
                          <CheckCircleOutlineIcon className="text-green-500" />
                          <div className=" text-gray-500 text-base px-3">
                            {t("YES")}
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    {item.callStatus == 30 || item.callStatus == 31 ? (
                      <>
                        <div className="flex items-center justify-center">
                          <CancelIcon className="text-red-500" />
                          <div className=" text-gray-500 text-base px-3">
                            {t("Ακυρώθηκε")}
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    {item.callStatus == 20 || item.callStatus == 21 ? (
                      <>
                        <div className="flex items-center justify-center">
                          <div className=" text-gray-500 text-base px-3">
                            {t("NO")}
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </td>
              </tr>
            </>
          ))}
        </tbody>
      </table>
      {/* Mobile Phones Table */}
      <table className="showSmallTable">
        <tbody>
          {data.map((item) => (
            <>
              <tr key={item.date} className="rounded-md">
                <div className="Primary_Main_Background text-white font-semibold text-end mt-2  rounded-t  p-1">
                  {item.receivedDate.split("T")[0] +
                    " " +
                    item.receivedDate.split("T")[1].split(".")[0]}
                </div>

                <div className="bg-gray-200  p-1 text-gray-500 text-base px-3">
                  {t("Destination") + " : "} {item.destination}
                </div>

                <div className="bg-gray-200  p-1 text-gray-500 text-base px-3">
                  {t("Comment") + " : "} {item.comments}
                </div>

                <div className="bg-gray-200  p-1">
                  {item.callStatus == 0 || item.callStatus == 1 ? (
                    <>
                      <div className="flex items-center">
                        <div className=" text-gray-500 text-base px-3">
                          {t("Ολοκληρώθηκε") + " : " + t("NO")}
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  {item.callStatus == 10 || item.callStatus == 11 ? (
                    <>
                      <div className="flex items-center">
                        <CheckCircleOutlineIcon className="text-green-500" />
                        <div className=" text-gray-500 text-base px-3">
                          {t("Ολοκληρώθηκε") + " : " + t("YES")}
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  {item.callStatus == 20 || item.callStatus == 21 ? (
                    <>
                      <div className="flex items-center">
                        <div className=" text-gray-500 text-base px-3">
                          {t("Ολοκληρώθηκε") + " : " + t("NO")}
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  {item.callStatus == 30 || item.callStatus == 31 ? (
                    <>
                      <div className="flex items-center">
                        <CancelIcon className="text-red-500" />
                        <div className=" text-gray-500 text-base px-3">
                          {t("Ακυρώθηκε")}
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>

                <div className="bg-gray-200 rounded-b-md p-1">
                  {item.callStatus == 30 || item.callStatus == 31 ? (
                    <>
                      <div className="flex items-center">
                        <div className=" text-gray-500 text-base px-3">
                          {t("Αποτέλεσμα_κλήσης")} {" : "} {item.taxiNo}
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </tr>
            </>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default HistoryTable;
